import { render } from "./QuestionsCourse.vue?vue&type=template&id=aa3c538c"
import script from "./QuestionsCourse.vue?vue&type=script&lang=js"
export * from "./QuestionsCourse.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__